// Phase 92D.2 — deterministic asset-ready tracker for PDF generation.
// AuthImg registers each pending image; the /print page waits until all settle
// (loaded or failed-to-fallback) before signalling window.__PDF_READY__.
let _pending = 0;
let _broken = [];

export const assetTracker = {
  register() { _pending += 1; },
  settle(brokenSrc) { _pending = Math.max(0, _pending - 1); if (brokenSrc) _broken.push(brokenSrc); },
  pending() { return _pending; },
  broken() { return _broken.slice(); },
  reset() { _pending = 0; _broken = []; },
};
